import { BellOff, Bell, Bell as BellIcon } from '@tamagui/lucide-icons'
import { ContextMenu, type ContextMenuSection } from '../../common'
import { useAppStore } from '@/store'
import type { NotificationLevel } from '@/types'

interface ChannelContextMenuProps {
  channelId: string
  x: number
  y: number
  onClose: () => void
}

export function ChannelContextMenu({ channelId, x, y, onClose }: ChannelContextMenuProps) {
  const { mutedChannelIds, toggleMuteChannel, channelNotificationLevels, setChannelNotificationLevel } = useAppStore()
  const isMuted = mutedChannelIds.includes(channelId)
  const currentLevel = channelNotificationLevels[channelId] || 'all'

  const levelLabels: { level: NotificationLevel; label: string }[] = [
    { level: 'all', label: 'All Messages' },
    { level: 'mentions', label: 'Mentions Only' },
    { level: 'nothing', label: 'Nothing' },
  ]

  const sections: ContextMenuSection[] = [
    {
      items: [
        {
          id: 'mute',
          label: isMuted ? 'Unmute Channel' : 'Mute Channel',
          icon: isMuted
            ? <Bell size={14} color="$sidebarMuted" />
            : <BellOff size={14} color="$sidebarMuted" />,
          action: () => toggleMuteChannel(channelId),
        },
      ],
    },
    {
      label: 'Notifications',
      items: levelLabels.map(({ level, label }) => ({
        id: `level-${level}`,
        label: `${currentLevel === level ? '● ' : ''}${label}`,
        icon: <BellIcon size={14} color={currentLevel === level ? '$accent' : '$sidebarMuted'} />,
        action: () => setChannelNotificationLevel(channelId, level),
      })),
    },
  ]

  return <ContextMenu x={x} y={y} sections={sections} onClose={onClose} />
}
